<template>
    <div class="background">
        <a-icon
            v-on:click="back"
            class="back-arrow"
            type="left" />
        <div class="title">
            {{ title }}
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';

 import Icon from "ant-design-vue/lib/icon";

 Vue.component(Icon.name, Icon);

 export default {
     name: 'Titlebar',
     props: {
         title: String
     },
     components: {
     },
     methods: {
         back() {
             this.$router.go(-1)
         }
     }
 }
</script>

<style scoped>
 .background {
     background-color: #444444;
     color: #FFF;
     width: 100%;
     height: 50px;
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;

     position: relative;
 }

 .back-arrow {
     left: 0px;
     position: absolute;
     width: 50px;
     height: 44px;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     font-size: 18px;
 }

 .back-arrow:active {
     background-color: #AAA;
 }

 .title {
     font-size: 16px;
 }
</style>
